import { styled as t, css as i } from "styled-components";
import { MediaQuery as e } from "../../styles/variables.js";
import { Theme as o } from "../../styles/themes/index.js";
t.ul`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 8px;
  transition: transform 0.7s ease-in-out;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${e.SCREEN_MD_UP} {
    overflow-x: hidden;
  }
`;
t.li`
  flex-shrink: 0;
`;
const r = i`
  width: 60px;
  height: 100%;
  top: 0;
  position: absolute;
  display: flex;
  align-items: center;

  & > button {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    border: 1px solid rgb(${o.colors.Golf});
    color: rgb(${o.colors.Alpha});
    background-color: rgb(${o.colors.Juliet});
    z-index: 1;

    i {
      font-size: 24px;
      margin-top: 2px;
    }
  }

  @media ${e.SCREEN_MD_UP} {
    width: 100px;

    & > button {
      width: 40px;
      height: 40px;
    }
  }

  &::before {
    content: ' ';
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }

  &[aria-hidden='true'] {
    display: none;
  }
`, p = t.div`
  ${r}
  right: 0;
  justify-content: flex-end;
  & > button {
    margin-right: 24px;
  }

  &::before {
    background: linear-gradient(to right, transparent 0, currentColor 76%);
  }
`, d = t.div`
  ${r}
  left: 0;
  justify-content: flex-start;
  & > button {
    margin-left: 24px;
  }

  &::before {
    background: linear-gradient(to left, transparent 0, currentColor 76%);
  }
`;
export {
  p as NextButtonWrapper,
  d as PrevButtonWrapper,
  r as navigationButtonStyle
};
